'use client';

import { cn } from '@/core/utils/cn';

interface AppShellProps {
  children: React.ReactNode;
  className?: string;
}

export function AppShell({ children, className }: AppShellProps) {
  return (
    <div className={cn('flex h-screen overflow-hidden bg-hms-bg', className)}>
      {children}
    </div>
  );
}
